













































import {
  defineComponent, ref, watch, PropType,
} from '@vue/composition-api';
import { IWarranty } from '~/types/fightcamp';

export default defineComponent({
  name: 'WarrantyUpsell',
  emits: ['removeWarranty', 'addWarranty'],
  props: {
    warranty: {
      type: Object as PropType<IWarranty>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selectedValue = ref('limited');

    watch(selectedValue, () => {
      if (selectedValue.value === 'limited') {
        emit('removeWarranty', props.warranty.itemId);
        return;
      }

      emit('addWarranty', props.warranty);
    });

    return {
      selectedValue,
    };
  },
});
